import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { ModalStep } from '../../utils/steps.js';
import { getActions } from './actions.js';
// Omitting step from default here since it's set dynamically when the modal opens and closes
export const DEFAULT_MODAL_STATE = {
    flow: undefined,
    stepDirection: 1,
    webAuthURLForLogin: undefined,
    webAuthURLForCreate: undefined,
    passwordUrlForLogin: undefined,
    passwordUrlForCreate: undefined,
    supportedAuthMethods: new Set(),
    onModalStepChange: undefined,
    onRampPurchase: undefined,
    popupWindow: undefined,
    isFullyLoggedIn: false,
    accountAddFundTab: undefined,
    isExternalWalletConnecting: false,
    externalWalletError: undefined,
    activeWallet: [undefined, undefined],
    farcasterConnectUri: undefined,
    biometricLocationHints: undefined,
};
export const useModalStore = create()(persist((set, get) => (Object.assign(Object.assign({ step: ModalStep.AUTH_MAIN, onRampConfig: undefined, activeWallet: undefined }, DEFAULT_MODAL_STATE), getActions(set, get))), {
    version: 1,
    name: '@CAPSULE/modalState',
    storage: createJSONStorage(() => sessionStorage),
    partialize: state => ({
        step: state.step,
        webAuthURLForLogin: state.webAuthURLForLogin,
        webAuthURLForCreate: state.webAuthURLForCreate,
        passwordUrlForLogin: state.passwordUrlForLogin,
        passwordUrlForCreate: state.passwordUrlForCreate,
        biometricLocationHints: state.biometricLocationHints,
        onRampPurchase: state.onRampPurchase,
        selectedExternalWalletId: state.selectedExternalWalletId,
        isUsingMobileConnector: state.isUsingMobileConnector,
        supportedAuthMethods: state.supportedAuthMethods,
    }),
}));
